<template>
  <tr v-bind="$attrs" ref="trigger" role="row" :class="tall ? 'tw-h-16' : 'tw-h-10'">
    <slot v-if="display"></slot>
  </tr>
</template>

<script>
export default {
  props: {
    root: {
      type: [Document, Element],
      default: null,
    },
    initialRender: {
      type: Boolean,
      default: false,
    },
    tall: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      display: this.initialRender,
    }
  },
  mounted() {
    if (typeof IntersectionObserver !== 'function') {
      this.display = true
    }
    if (!this.display) {
      const observer = new IntersectionObserver(
        ([{ isIntersecting, boundingClientRect }]) => {
          if (isIntersecting || boundingClientRect.top < 0) {
            this.display = true
            observer.disconnect()
          }
        },
        {
          root: this.root,
          // rootMargin: "100px",
          // threshold: .01,
        },
      )
      observer.observe(this.$refs.trigger)
    }
  },
}
</script>
